import React from 'react';
import { KHANOUMI_HOLIDAYS } from '../constants';
function HolidayCalendar() {
  return <div className='col-span-full flex flex-col gap-4 lg:gap-8' data-sentry-component="HolidayCalendar" data-sentry-source-file="holiday-calendar.tsx">
            <span className='text-body-14 font-bold lg:text-body-16'>تقویم تعطیلات پشتیبانی خانومی</span>

            <div className='grid grid-cols-3 gap-3 lg:grid-cols-4 lg:gap-4'>
                {KHANOUMI_HOLIDAYS.map(holiday => {
        return <div key={holiday.date} className='flex h-18 cursor-default flex-col items-center justify-center gap-2 rounded border border-border-gray-light bg-surface-solid-50 px-2 text-center lg:h-24'>
                            <span className='text-body-14 font-bold lg:text-body-16'>{holiday.date}</span>
                            <span className='text-caption-12 lg:text-body-14'>{holiday.title}</span>
                        </div>;
      })}
            </div>
        </div>;
}
export default HolidayCalendar;